import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ReactSession } from "react-client-session";
import "./BaaHam_ContentproductionUser_Make.css";

import { AiOutlinePlusCircle } from "react-icons/ai";
import Select from "react-select";
import { useMediaQuery } from "react-responsive";
import { TiTick } from "react-icons/ti";
import { BiImageAdd } from "react-icons/bi";
import { AiOutlinePicture } from "react-icons/ai";
import Image6 from "../../../../pic1.jpg";

function BaaHam_ContentproductionUser_Make() {
    ReactSession.setStoreType("localStorage");
    const UserId = ReactSession.get("UserId");
    const UserType = ReactSession.get("UserType");

    const [editorValue, setEditorValue] = useState("");
    const Editor = {
        modules: {
            toolbar: [
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                [{ size: ["small", false, "large", "huge"] }],
                [{ color: [] }, { background: [] }],
                [{ font: [] }],
                [{ align: [] }],
                ["bold", "italic", "underline", "strike", "blockquote"],
                [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
                ["link", "image", "video"],
                [{ direction: "rtl" }],
                ["clean"],
            ],
            clipboard: {
                // toggle to add extra line breaks when pasting HTML:
                matchVisual: false,
            },
        },
        formats: ["header", "font", "size", "bold", "italic", "underline", "strike", "blockquote", "list", "bullet", "indent", "link", "image", "video"],
    };
    const [userData, setUserData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: null,
        password: "",
        isDeleted: false,
        type: "producerUser",
        active: true,
        createdAt: "",
        updatedAt: "",
        id: "",
    });

    useEffect(() => {
        if (UserId) {
            axios
                .get("https://hammaskan.ir:8443/api/users/" + UserId, {
                    params: {},
                })
                .then((res) => {
                    // console.log(res.data.data);
                    setUserData(res.data.data);
                })
                .catch((error) => {
                    // console.log(error);
                    window.location.href = "./Account";
                });
        } else {
            window.location.href = "./Account";
        }
    }, []);

    const [ImageSrc, setImageSrc] = useState("");
    const [ImageData, setImageData] = useState("");
    const [Tick, setTick] = useState(1);
    const res500 = useMediaQuery({ query: "(max-width: 500px)" });
    const res600 = useMediaQuery({ query: "(max-width: 600px)" });
    const res700 = useMediaQuery({ query: "(max-width: 700px)" });
    const [AgahiSwitch, setAgahiSwitch] = useState(1);
    let selectHeight = "36px";
    if (res700) {
        selectHeight = "33px";
    }

    const customStyles = {
        control: (base, state) => ({
            ...base,
            /*borderColor: state.isFocused ? "yellow" : "green",
      "&:hover": {
      borderColor: state.isFocused ? "red" : "blue"
      }*/
            minHeight: selectHeight,
            height: selectHeight,
            width: "100%",
            border: "none",
            borderRadius: "10px",
            backgroundColor: "rgb(245, 245, 245)",
            "&:hover": {
                borderColor: "#d1d1d1",
            },
            "&:focus": {
                borderColor: "#d1d1d1",
            },
            "&:active": {
                borderColor: "#d1d1d1",
            },
            display: "flex",
        }),
        option: (provided, state) => ({
            ...provided,
        }),
        indicatorSeparator: (styles) => ({ display: "none" }),
        singleValue: (provided) => ({
            ...provided,
            color: "rgb(98, 98, 98)",
            fontSize: res500 ? "8px" : res600 ? "9px" : res700 ? "10px" : "12px",
            display: "flex",
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            height: selectHeight,
            display: "flex",
            fontSize: "13px",
            color: "rgb(178, 178, 178)",
            fontWeight: "bold",
        }),
        input: (provided, state) => ({
            ...provided,
            margin: "0px",
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: selectHeight,
        }),

        dropdownIndicator: (base) => ({
            ...base,
            fontSize: res600 ? "6px" : "8px",

            "&:hover": {
                color: "#5843b1",
            },
            paddingTop: 2,
            paddingBottom: 2,
        }),
        clearIndicator: (styles) => ({
            ...styles,
            paddingTop: 2,
            paddingBottom: 2,
        }),
        menu: (base) => ({
            ...base,
            // override border radius to match the box
            borderRadius: 0,
            // kill the gap
            marginTop: 0,
        }),
    };

    const optionsList1 = [
        { label: "Option 1", value: "Option 1" },
        { label: "Option 2", value: "Option 2" },
        { label: "Option 3", value: "Option 3" },
        { label: "Option 4", value: "Option 4" },
    ];

    const regPost = () => {
        var DialogWait = document.getElementById("labelLSGNDialogWait");
        var DialogOk = document.getElementById("labelLSGNDialogOk");
        var DialogErr = document.getElementById("labelLSGNDialogErr");

        DialogWait.style.display = "inline-block";
        DialogOk.style.display = "none";
        DialogErr.style.display = "none";

        var postTitle = document.getElementById("postTitle").value;
        if (ImageData && postTitle && editorValue) {
            console.log(ImageData.name);
            let reader = new FileReader();
            reader.readAsDataURL(ImageData);
            reader.onload = function () {
                axios({
                    url: "https://hammaskan.ir:8443/api/data/image/row",
                    method: "POST",
                    data: {
                        imageData: reader.result,
                        imageName: ImageData.name,
                        dataType: ImageData.type,
                        dataUseType: UserType,
                        dataOwnerId: UserId,
                    },
                    maxContentLength: "infinity",
                    maxBodyLength: "infinity",
                })
                    .then((res) => {
                        console.log(res);
                        var ImageLink = res.data.data.link;
                        console.log(ImageLink);
                        axios
                            .post("https://hammaskan.ir:8443/api/posts", {
                                image: ImageLink,
                                text: editorValue,
                                title: postTitle,
                                writer: UserId,
                            })
                            .then((res) => {
                                setTimeout(() => {
                                    DialogWait.style.display = "none";
                                    DialogOk.style.display = "inline-block";
                                    DialogErr.style.display = "none";
                                    console.log(res);
                                }, 300);
                            })
                            .catch((error) => {
                                setTimeout(() => {
                                    DialogWait.style.display = "none";
                                    DialogOk.style.display = "none";
                                    DialogErr.style.display = "inline-block";
                                    DialogErr.textContent = "در ذخیره سازی پست مورد نظر مشکلی وجود دارد";
                                }, 300);
                            });
                    })
                    .catch((error) => {
                        setTimeout(() => {
                            DialogWait.style.display = "none";
                            DialogOk.style.display = "none";
                            DialogErr.style.display = "inline-block";
                            DialogErr.textContent = "حجم فایل بارگزاری شده بیش از حد مجاز است";
                        }, 300);
                    });
            };
        } else {
            setTimeout(() => {
                DialogWait.style.display = "none";
                DialogOk.style.display = "none";
                DialogErr.style.display = "inline-block";
                DialogErr.textContent = "لطفا اطلاعات را کامل وارد کنید";
            }, 300);
        }
    };

    return (
        <div className="BaaHam_ContentproductionUser_Make" style={{ height: "auto" }}>
            {/* <div className="BaaHam_NU_ProfileButtonContainer">
                <div className="BaaHam_NU_ProfileButton BaaHam_CPU_MakeTopButton">
                    <AiOutlinePlusCircle className="BaaHam_CPU_MakeTopButtonPlus" />
                    <span>افزودن نوشته</span>
                </div>
            </div> */}
            <div className="BaaHam_NU_ProfileInputContainer">
                <span className="BaaHam_NU_ProfileInputTitle">
                    عنوان نوشته <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                </span>
                <div className="InputExactContainerForBack">
                    <input className="BaaHam_NU_ProfileInput" id="postTitle" type="text" />
                </div>
            </div>
            {/*<CKEditor
          editor={ClassicEditor}
          config={ {
      
            // Use the German language for this editor.
            language: {
              // The UI will be English.
              ui: 'ar',
  
              // But the content will be edited in Arabic.
              content: 'ar'
          }
    
            // ...
        } }
      />*/}

            <div className="BaaHam_CU_MakeFooter">
                {/* <div className="BaaHam_CU_MakeFooterRight">
                    <div className="BaaHam_CU_MakeFooterRightFooter">
                        <span className="BaaHam_NormalUsers_SabteAgahiAreaSelectTitle BaaHam_ContentproductionUser_MakeTitleRes ">وضعیت:</span>
                        <div className="BaaHam_ContentproductionUser_MakePishMonContainer">
                            <div className="BaaHam_CU_MakeFooterRightFooterItem">
                                <div className="BaaHam_CU_MakeFooterRightTick" onClick={() => setTick(1)}>
                                    {Tick === 1 ? <TiTick className="BaaHam_CU_MakeFooterRightTickExact" /> : ""}
                                </div>
                                <span className="BaaHam_NormalUsers_SabteAgahiAreaSelectTitle BaaHam_ContentproductionUser_MakeTitleRes">پیش نویس</span>
                            </div>
                            <div className="BaaHam_CU_MakeFooterRightFooterItem">
                                <div className="BaaHam_CU_MakeFooterRightTick" onClick={() => setTick(2)}>
                                    {Tick === 2 ? <TiTick className="BaaHam_CU_MakeFooterRightTickExact" /> : ""}
                                </div>
                                <span className="BaaHam_NormalUsers_SabteAgahiAreaSelectTitle BaaHam_ContentproductionUser_MakeTitleRes">منتشر شده </span>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className="BaaHam_CU_MakeFooterLeft">
                    <span className="BaaHam_NormalUsers_SabteAgahiAreaSelectTitle">
                        ویرایش تصویر <span className="BaaHam_NU_ProfileInputTitleStar">*</span>{" "}
                    </span>
                    <div className="BaaHam_CU_SabteAgahiPicsContainer">
                        {ImageSrc ? (
                            <img className="BuyCardImage" alt="" src={ImageSrc} />
                        ) : (
                            <div className="waitforimage2">
                                <input
                                    className="imageInput"
                                    id="Imageinput"
                                    type="file"
                                    onChange={(e) => {
                                        setImageSrc(URL.createObjectURL(e.target.files[0]));
                                        setImageData(e.target.files[0]);
                                    }}
                                />
                                <label className="ImageInputLabel2" htmlFor="Imageinput">
                                    {" "}
                                    <img className="ImageInputLabel2Pic" alt="" src={Image6} />{" "}
                                </label>
                            </div>
                        )}
                        <div className="BaaHam_CU_SabteAgahiPicsContainerDeleteContainer">
                            <span className="BaaHam_CU_SabteAgahiPicsContainerDeleteTitle" onClick={() => setImageSrc("")}>
                                حذف تصویر
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="BaaHam_ContentproductionUser_MakeEditorContianer" style={{ height: "auto" }}>
                <ReactQuill theme="snow" value={editorValue} onChange={setEditorValue} modules={Editor.modules} formats={Editor.formats} placeholder={"متن نوشته خود را وارد نمایید"} />
            </div>

            <div className="labelLSGN" id="labelLSGNDialogWait" style={{ display: "none", fontSize: "14px", backgroundColor: "#1B9CFC", color: "snow", width: "95%", padding: "12px 8px", borderRadius: "6px" }}>
                لطفا کمی صبر کنید ...
            </div>
            <div className="labelLSGN" id="labelLSGNDialogOk" style={{ display: "none", fontSize: "14px", backgroundColor: "#06d6a0", color: "snow", width: "95%", padding: "12px 8px", borderRadius: "6px", margin: "12px 0" }}>
                پست مورد نظر با موفقیت ثبت شد
            </div>
            <div className="labelLSGN" id="labelLSGNDialogErr" style={{ display: "none", fontSize: "14px", backgroundColor: "tomato", color: "snow", width: "95%", padding: "12px 8px", borderRadius: "6px", margin: "12px 0" }}>
                --
            </div>
            <div className="BaaHam_NU_ProfileButtonContainer">
                <div className="BaaHam_NU_ProfileButton" onClick={regPost}>
                    <span>ثبت نوشته</span>
                </div>
            </div>
        </div>
    );
}

export default BaaHam_ContentproductionUser_Make;
